module.exports = __webpack_public_path__ + "img/desert_island.e3729342.gif";